(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {

  // =========================
  // 1. CARD TOGGLE LOGIC
  // =========================
  const highlight = e.target.closest('.card-highlight');
  if (highlight) {
    const card = highlight.closest('.card-wrapper');
    if (!card) return;

    card.classList.toggle('is-highlighted');
    return;
  }

  // =========================
  // 2. SIZE SELECT + ADD TO CART
  // =========================
  const btn = e.target.closest('.size-btn');
  if (!btn) return;

  const form = btn.closest('product-form');
  if (!form) return;

  const variantInput = form.querySelector('.variant-id-input');

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  // set variant
  variantInput.value = variantId;

  // UI active state
  form.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');

  // trigger Shopify native submit (IMPORTANT)
  const submitBtn = form.querySelector('button[type="submit"], .hidden-submit');

  if (submitBtn) {
    submitBtn.click();
  }

});
  } catch(e) { console.error(e); }
})();

})();
